import DOMPurify from 'dompurify';
import { marked, Renderer } from 'marked';
import { parseHelpCenterFrontmatter, rewriteHelpCenterHref } from './helpCenterMarkdown';

const HELP_CENTER_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'h4',
  'ul',
  'ol',
  'li',
  'a',
  'div',
  'span',
  'blockquote',
  'code',
  'pre',
  'hr',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
];

const HELP_CENTER_ALLOWED_ATTR = ['href', 'title', 'target', 'rel'];

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const renderer = new Renderer();
renderer.link = (href: string, title: string | null | undefined, text: string) => {
  const nextHref = rewriteHelpCenterHref(href ?? '');
  const titleAttr = title ? ` title="${escapeHtml(title)}"` : '';
  const external = /^(https?:)/i.test(nextHref);
  const relAttr = external ? ' target="_blank" rel="noopener noreferrer"' : '';
  return `<a href="${escapeHtml(nextHref)}"${titleAttr}${relAttr}>${text}</a>`;
};

marked.setOptions({
  renderer,
  gfm: true,
  headerIds: false,
  mangle: false,
});

export function sanitizeHelpCenterHtml(html: string): string {
  return DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: HELP_CENTER_ALLOWED_TAGS,
    ALLOWED_ATTR: HELP_CENTER_ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}

export function renderHelpCenterMarkdown(markdown: string): string {
  const { body } = parseHelpCenterFrontmatter(markdown);
  const html = marked(body) as string;
  return sanitizeHelpCenterHtml(html);
}
